@if (form) {
  <form class="form" [formGroup]="form" (ngSubmit)="submitForm()">
    <div class="form__top">
      <div class="form__title">{{ edition ? (info?.title_edit | translate) : (info?.title | translate) }}</div>
      <div class="form__description">{{ info?.description | translate }}</div>
    </div>
    @if (periodValues.length) {
      <div class="form__content">
        <div class="form__period">
          <div class="form__label">{{ 't.period' | translate }}</div>
          <app-form-input class="input-item">
            <app-select class="select" formControlName="period" (change)="onPeriodChange()">
              <app-select-header [arrowBorder]="true" class="select__header">
                {{'t.select-period' | translate}}
              </app-select-header>
              <app-select-dropdown class="select__dropdown">
                @for (value of periodValues; track value) {
                  <app-select-option class="select__option" [value]="value.value">
                    {{ value.message | translate }}
                  </app-select-option>
                }
              </app-select-dropdown>
            </app-select>
          </app-form-input>
        </div>
        <div class="form__accounts" formGroupName="accounts">
          <div class="form__label">{{ 'labl.amount' | translate }}</div>
          <div class="form__accounts--list">
            @for (account of accounts; track account) {
              <app-form-input
                class="input-item"
                [errors]="errors?.accounts && errors?.accounts[account.currency] || []"
                [control]="form.controls['accounts'].get(account.currency)"
                [label]="account?.currency"
                >
                <input class="input input--simple" type="number" [formControlName]="account.currency">
              </app-form-input>
            }
          </div>
        </div>
      </div>
      <div class="submit-container">
        @if (edition && limit.status === Status.ACTIVE) {
          <button type="button" (click)="cancelLimit()" class="btn small cancel">
            {{'btn.cancel' | translate}}
          </button>
        }
        <button type="submit" class="btn small">{{'t.apply' | translate}}</button>
      </div>
    } @else {
      <div class="form__limits-set">
        {{ 't.all-limits-set' | translate }}
      </div>
    }
  </form>
}
